// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_9P5","cls2":"CiterightMiniReport-cls2_bV2 CiterightMiniReport-cls1_9P5"};